"use client";

import { useState } from "react";

interface BlogShareProps {
  title: string;
  excerpt: string;
}

export default function BlogShare({ title, excerpt }: BlogShareProps) {
  const [shareText, setShareText] = useState("SHARE POST");
  const [showShareModal, setShowShareModal] = useState(false);

  return (
    <>
      <button
        onClick={async () => {
          const url = window.location.href;

          // Try Web Share API first
          if (navigator.share) {
            try {
              await navigator.share({
                title: title,
                text: excerpt,
                url: url,
              });
              return; // Share successful
            } catch (error) {
              // User cancelled or share failed
              return;
            }
          }

          // Fallback: Open Custom Share Modal
          setShowShareModal(true);
        }}
        className="mt-4 bg-transparent border-[2px] border-[#1a1a1a] py-2 px-4 cursor-pointer font-mono transition-all duration-200 hover:bg-[#1a1a1a] hover:text-[#e4e2dd]"
      >
        {shareText}
      </button>

      {/* CUSTOM SHARE MODAL */}
      {showShareModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
          onClick={() => setShowShareModal(false)}
        >
          <div
            className="bg-[#e4e2dd] border-[3px] border-[#1a1a1a] p-6 w-full max-w-sm flex flex-col gap-4 rounded-[10px]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-2">
              <h3 className="font-bold uppercase tracking-widest text-[#1a1a1a]">
                Share Post
              </h3>
              <button
                onClick={() => setShowShareModal(false)}
                className="text-xl font-bold hover:opacity-50"
              >
                &times;
              </button>
            </div>

            <div className="flex flex-col gap-3">
              <button
                onClick={() => {
                  navigator.clipboard
                    .writeText(window.location.href)
                    .then(() => {
                      setShareText("LINK COPIED!");
                      setTimeout(() => setShareText("SHARE POST"), 2000);
                      setShowShareModal(false);
                    })
                    .catch(() => alert("Failed to copy link"));
                }}
                className="w-full bg-white border-[2px] border-[#1a1a1a] py-3 px-4 font-mono text-left flex items-center gap-3 hover:bg-[#ccc] transition-colors"
              >
                <span>🔗</span> Copy Link
              </button>

              <a
                href={`https://wa.me/?text=${encodeURIComponent(
                  title +
                    " - " +
                    (typeof window !== "undefined" ? window.location.href : "")
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-[#25D366] text-white border-[2px] border-[#1a1a1a] py-3 px-4 font-mono text-left flex items-center gap-3 hover:opacity-90 transition-opacity no-underline"
              >
                <span>💬</span> Share on WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
